var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-wrap",attrs:{"id":"mainWrap"}},[_c('KHeader',{attrs:{"scrollTop":_vm.scrollTop,"scrollFlag":_vm.scrollFlag}}),_c('div',{staticClass:"content"},[_c('RouterView',{attrs:{"scrollFlag":_vm.scrollFlag}})],1),_c('KFooter'),_c('KBacktop',{attrs:{"show":_vm.showBackTop}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }